<template>
    <div id="index">
        <div v-if="is_display">
            <div class="ui top attached tabular menu">
                <a class="item" :class="{active: current_component == 'GlobalMonitor'}" v-if="current_staff.theme_name == 'manager'"
                    @click="current_component = 'GlobalMonitor'">
                    <!-- 全部 -->
                    {{ $t('ui.pages.monitor.menu_title.all') }}
                </a>
                <a class="item" :class="{active: current_component == 'PersonalMonitor'}"
                    @click="current_component = 'PersonalMonitor'">
                    <!-- 個人 -->
                    {{ $t('ui.pages.monitor.menu_title.myself') }}
                </a>
                <a class="item" :class="{active: current_component == 'StationalMonitor'}" v-if="current_staff.station_identity"
                    @click="current_component = 'StationalMonitor'">
                    <!-- 站點 -->
                    {{ $t('ui.pages.monitor.menu_title.station') }}
                </a>
            </div>

            <div class="ui bottom attached tab segment active">
                <component :is="current_component">
                </component>
            </div>
        </div>
        <div v-else class="ui raised segment center aligned">
            <h2>
                {{ $t('ui.pages.provider_home.title') }}
            </h2>
        </div>
    </div>
</template>

<script>
import PersonalMonitor from '@components/monitor/personal/index.vue'
import StationalMonitor from '@components/monitor/stational/index.vue'
import GlobalMonitor from '@components/monitor/global/index.vue'
export default {
    name: "ProviderIndex",
    props: {
    },
    data() {
        return {
            is_display: false,
            is_loading: false,
            current_component: ""
        }
    },
    computed: {
        current_staff() {
            return this.$store.state.provider.current_staff
        }
    },
    mounted() {
        var that = this
        that.set_breadcrumbs()
        that.current_component = (that.current_staff.theme_name == 'manager') ? "GlobalMonitor" : "PersonalMonitor"
        // $('.menu .item').tab()
    },
    watch: {
        '$route'(to, from) {
            var that = this
            that.set_breadcrumbs()
        }
    },
    methods: {
        set_breadcrumbs() {
            var that = this
            that.$store.state.breadcrumbs = []
        },
    },
    components: {
        PersonalMonitor,
        StationalMonitor,
        GlobalMonitor,
    }
}
</script>

<style scoped lang="scss">
</style>
